export const getStates = country => {
    switch (country) {
        case 'US':
            return usStates
        case 'BR':
            return brazilStates
        default:
            return canadaStates
    }
}

export const getStateValue =
    (country = 'CA') =>
    value => {
        const states = getStates(country)

        return states.find(state => state.value === value) || ''
    }

export const getCountryValue = value => countries.find(country => country.value === value)

export const CAPostalCodeRegex = /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] [0-9][ABCEGHJ-NPRSTV-Z][0-9]$/
export const CAPostalCodeRegexString = '^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] [0-9][ABCEGHJ-NPRSTV-Z][0-9]$'

const US_COUNTRY_OPTION = { label: 'United States', value: 'US' }
const CA_COUNTRY_OPTION = { label: 'Canada', value: 'CA' }
const BR_COUNTRY_OPTION = { label: 'Brazil', value: 'BR' }
const CO_COUNTRY_OPTION = { label: 'Colombia', value: 'CO' }

// Country options rules:
// - CA environment: allow selecting US/CA
// - BR environment: only BR
// - CO environment: only CO
const getCountriesForEnvironment = () => {
    const currentCountry = (window.COUNTRY || window.COUNTRY_PURCHASE_FLOW || '').toUpperCase()

    if (currentCountry === 'BR' || currentCountry === 'BR-NEO') {
        return [BR_COUNTRY_OPTION]
    }
    if (currentCountry === 'CO') {
        return [CO_COUNTRY_OPTION]
    }
    // CA or default
    return [US_COUNTRY_OPTION, CA_COUNTRY_OPTION]
}

export const countries = getCountriesForEnvironment()

export const canadaStates = [
    {
        label: <T>states.canada.Alberta</T>,
        value: 'AB',
    },
    {
        label: <T>states.canada.British.Columbia</T>,
        value: 'BC',
    },
    {
        label: <T>states.canada.Manitoba</T>,
        value: 'MB',
    },
    {
        label: <T>states.canada.New.Brunswick</T>,
        value: 'NB',
    },
    {
        label: <T>states.canada.Newfoundland.and.Labrador</T>,
        value: 'NL',
    },
    {
        label: <T>states.canada.Northwest.Territories</T>,
        value: 'NT',
    },
    {
        label: <T>states.canada.Nova.Scotia</T>,
        value: 'NS',
    },
    {
        label: <T>states.canada.Nunavut</T>,
        value: 'NU',
    },
    {
        label: <T>states.canada.Ontario</T>,
        value: 'ON',
    },
    {
        label: <T>states.canada.Prince.Edward.Island</T>,
        value: 'PE',
    },
    {
        label: <T>states.canada.Quebec</T>,
        value: 'QC',
    },
    {
        label: <T>states.canada.Saskatchewan</T>,
        value: 'SK',
    },
    {
        label: <T>states.canada.Yukon</T>,
        value: 'YT',
    },
]

export const usStates = [
    {
        label: <T>states.usa.Alabama</T>,
        value: 'AL',
    },
    {
        label: <T>states.usa.Alaska</T>,
        value: 'AK',
    },
    {
        label: <T>states.usa.Arizona</T>,
        value: 'AZ',
    },
    {
        label: <T>states.usa.Arkansas</T>,
        value: 'AR',
    },
    {
        label: <T>states.usa.California</T>,
        value: 'CA',
    },
    {
        label: <T>states.usa.Colorado</T>,
        value: 'CO',
    },
    {
        label: <T>states.usa.Connecticut</T>,
        value: 'CT',
    },
    {
        label: <T>states.usa.Delaware</T>,
        value: 'DE',
    },
    {
        label: <T>states.usa.District.of.Columbia</T>,
        value: 'DC',
    },
    {
        label: <T>states.usa.Florida</T>,
        value: 'FL',
    },
    {
        label: <T>states.usa.Georgia</T>,
        value: 'GA',
    },
    {
        label: <T>states.usa.Hawaii</T>,
        value: 'HI',
    },
    {
        label: <T>states.usa.Idaho</T>,
        value: 'ID',
    },
    {
        label: <T>states.usa.Illinois</T>,
        value: 'IL',
    },
    {
        label: <T>states.usa.Indiana</T>,
        value: 'IN',
    },
    {
        label: <T>states.usa.Iowa</T>,
        value: 'IA',
    },
    {
        label: <T>states.usa.Kansas</T>,
        value: 'KS',
    },
    {
        label: <T>states.usa.Kentucky</T>,
        value: 'KY',
    },
    {
        label: <T>states.usa.Louisiana</T>,
        value: 'LA',
    },
    {
        label: <T>states.usa.Maine</T>,
        value: 'ME',
    },
    {
        label: <T>states.usa.Maryland</T>,
        value: 'MD',
    },
    {
        label: <T>states.usa.Massachusetts</T>,
        value: 'MA',
    },
    {
        label: <T>states.usa.Michigan</T>,
        value: 'MI',
    },
    {
        label: <T>states.usa.Minnesota</T>,
        value: 'MN',
    },
    {
        label: <T>states.usa.Mississippi</T>,
        value: 'MS',
    },
    {
        label: <T>states.usa.Missouri</T>,
        value: 'MO',
    },
    {
        label: <T>states.usa.Montana</T>,
        value: 'MT',
    },
    {
        label: <T>states.usa.Nebraska</T>,
        value: 'NE',
    },
    {
        label: <T>states.usa.Nevada</T>,
        value: 'NV',
    },
    {
        label: <T>states.usa.New.Hampshire</T>,
        value: 'NH',
    },
    {
        label: <T>states.usa.New.Jersey</T>,
        value: 'NJ',
    },
    {
        label: <T>states.usa.New.Mexico</T>,
        value: 'NM',
    },
    {
        label: <T>states.usa.New.York</T>,
        value: 'NY',
    },
    {
        label: <T>states.usa.North.Carolina</T>,
        value: 'NC',
    },
    {
        label: <T>states.usa.North.Dakota</T>,
        value: 'ND',
    },
    {
        label: <T>states.usa.Ohio</T>,
        value: 'OH',
    },
    {
        label: <T>states.usa.Oklahoma</T>,
        value: 'OK',
    },
    {
        label: <T>states.usa.Oregon</T>,
        value: 'OR',
    },
    {
        label: <T>states.usa.Pennsylvania</T>,
        value: 'PA',
    },
    {
        label: <T>states.usa.Rhode.Island</T>,
        value: 'RI',
    },
    {
        label: <T>states.usa.South.Carolina</T>,
        value: 'SC',
    },
    {
        label: <T>states.usa.South.Dakota</T>,
        value: 'SD',
    },
    {
        label: <T>states.usa.Tennessee</T>,
        value: 'TN',
    },
    {
        label: <T>states.usa.Texas</T>,
        value: 'TX',
    },
    {
        label: <T>states.usa.Utah</T>,
        value: 'UT',
    },
    {
        label: <T>states.usa.Vermont</T>,
        value: 'VT',
    },
    {
        label: <T>states.usa.Virginia</T>,
        value: 'VA',
    },
    {
        label: <T>states.usa.Washington</T>,
        value: 'WA',
    },
    {
        label: <T>states.usa.West.Virginia</T>,
        value: 'WV',
    },
    {
        label: <T>states.usa.Wisconsin</T>,
        value: 'WI',
    },
    {
        label: <T>states.usa.Alabama</T>,
        value: 'WY',
    },
]

export const brazilStates = [
    {
        value: 'AC',
        label: 'Acre',
    },
    {
        value: 'AL',
        label: 'Alagoas',
    },
    {
        value: 'AP',
        label: 'Amapá',
    },
    {
        value: 'AM',
        label: 'Amazonas',
    },
    {
        value: 'BA',
        label: 'Bahia',
    },
    {
        value: 'CE',
        label: 'Ceará',
    },
    {
        value: 'DF',
        label: 'Distrito Federal',
    },
    {
        value: 'ES',
        label: 'Espírito Santo',
    },
    {
        value: 'GO',
        label: 'Goiás',
    },
    {
        value: 'MA',
        label: 'Maranhão',
    },
    {
        value: 'MT',
        label: 'Mato Grosso',
    },
    {
        value: 'MS',
        label: 'Mato Grossodo Sul',
    },
    {
        value: 'MG',
        label: 'Minas Gerais',
    },
    {
        value: 'PA',
        label: 'Pará',
    },
    {
        value: 'PB',
        label: 'Paraíba',
    },
    {
        value: 'PR',
        label: 'Paraná',
    },
    {
        value: 'PE',
        label: 'Pernambuco',
    },
    {
        value: 'PI',
        label: 'Piauí',
    },
    {
        value: 'RJ',
        label: 'Rio de Janeiro',
    },
    {
        value: 'RN',
        label: 'Rio Grande do Norte',
    },
    {
        value: 'RS',
        label: 'Rio Grande do Sul',
    },
    {
        value: 'RO',
        label: 'Rondônia',
    },
    {
        value: 'RR',
        label: 'Roraima',
    },
    {
        value: 'SC',
        label: 'Santa Catarina',
    },
    {
        value: 'SP',
        label: 'São Paulo',
    },
    {
        value: 'SE',
        label: 'Sergipe',
    },
    {
        value: 'TO',
        label: 'Tocantins',
    },
]
